export default "__VITE_ASSET__COmQgBfu__"